import React from 'react';
// @ts-ignore
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import {
    FormSelectChoice,
    FormFieldComponentProps,
    VerificationServiceProps,
    Country,
    Locale,
    FieldLabel,
    getLocaleSafely,
    getOptions,
    getOrgSearchCountryTags,
    getSafe,
} from '@sheerid/jslib';
import { TypeaheadComponent } from '../../FormInputs/Typeahead/TypeaheadComponent';

export const CollegeName = ({
    onChange,
    value,
    isErrored,
    verificationService,
    intl,
    placeholder = '',
    isRequired = true,
}: FormFieldComponentProps & VerificationServiceProps) => {
    const { programId, viewModel, verificationResponse } = verificationService;
    const locale: Locale = getLocaleSafely(viewModel, verificationResponse);
    const urlAddSchoolForm = (getOptions().urlAddSchoolForm || '').trim();
    const country = getSafe<Country>(() => verificationService.viewModel.countryChoice.value);
    const searchTags = getOrgSearchCountryTags(verificationService.programTheme, country);
    const [floatLabel, setFloatLabel] = React.useState(getSafe(() => !!value.name.length, false));
    const [focus, setFocus] = React.useState(false);

    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        if (getSafe(() => event.target.value)) {
            setFloatLabel(true);
        } else {
            setFloatLabel(false);
        }
    };

    return (
        <div className={`sid-field sid-college-name-id ${focus ? 'sid-focused' : ''}`}>
            <div className="sid-l-space-top-md" />
            <FieldLabel
                text={<FormattedHTMLMessage id="schoolName" defaultMessage="University / College name" />}
                htmlForLabel="sid-college-name"
                id="sid-college-name-label"
                displayClasses={`${placeholder && 'sid-h-screen-reader-only'} ${floatLabel ? 'sid-field__label--floating' : ''}`}
            />

            <TypeaheadComponent
                className={isErrored ? 'sid-text-input--error' : ''}
                countryCode={country}
                minimumSearchValueLength={getOptions().minimumOrganizationSearchLength}
                onChange={(choice: FormSelectChoice) => onChange(choice)}
                onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                    handleOnBlur(event);
                    setFocus(false);
                }}
                onFocus={() => {
                    setFloatLabel(true);
                    setFocus(true);
                }}
                placeholder={
                    placeholder
          || intl.formatMessage({
              id: 'schoolNamePlaceholder',
              defaultMessage: 'University / College name*',
          })
                }
                programId={programId}
                value={value}
                inputHtmlId="sid-college-name"
                openOrgSearchEnabled={verificationService.programTheme.openOrgSearchEnabled}
                orgSearchUrl={verificationService.programTheme.config.orgSearchUrl}
                orgSearchTags={searchTags}
                locale={locale}
                urlAddSchoolForm={urlAddSchoolForm}
                isRequired={isRequired}
            />

            {isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage
                        id="errorId.invalidOrganization"
                        defaultMessage="You must select an organization from the list"
                    />
                </div>
            ) : null}
        </div>
    );
};

export const CollegeNameComponent = injectIntl(CollegeName);
